import { axiosApiInstance } from "@/libs/axios.tsx";
import { API_ENDPOINTS, WORKSPACES_API_ENDPOINTS } from "@/constants/api.ts";
import { Req } from "@/features/calendar/types/create-slot.ts";

export const createSlot = async (reqData: Req) => {
  return axiosApiInstance.post<{ code: string; message: string }>(
    `${API_ENDPOINTS.TUTOR.CALENDAR.CREATE_SLOT}?start_time=${reqData.start_time}&end_time=${reqData.end_time}&lesson_host=${reqData.lesson_host}&overlap_gc=${reqData.overlap_gc}${reqData.communication_details ? `&communication_details=${reqData.communication_details}` : ""}`,
  );
};
export const updateSlot = async (reqData: Req, slotId: string) => {
  return axiosApiInstance.put<{ code: string; message: string }>(
    `${API_ENDPOINTS.TUTOR.CALENDAR.UPDATE_SLOT}/${slotId}/update?start_time=${reqData.start_time}&end_time=${reqData.end_time}&lesson_host=${reqData.lesson_host}&overlap_gc=${reqData.overlap_gc}${reqData.communication_details ? `&communication_details=${reqData.communication_details}` : ""}`,
  );
};
export const deleteSlot = async (slotId: string) => {
  return axiosApiInstance.delete<{ code: string; message: string }>(
    `${API_ENDPOINTS.TUTOR.CALENDAR.DELETE_SLOT}/${slotId}/delete`,
  );
};

interface Subject {
  id: string;
  name: string;
  icon: string;
  is_group_subject: boolean;
}

interface CurriculumLevel {
  id: string;
  name: string;
  description: string;
}

export interface SubjectWithLevels {
  subject: Subject;
  curriculum_levels: CurriculumLevel[];
  children?: SubjectWithLevels[];
  is_selectable: boolean;
}

export const getWorkspaceTutorSubjectsWithLevels = async (workspaceId: string) => {
  return axiosApiInstance.get<{
    data: SubjectWithLevels[];
  }>(`${WORKSPACES_API_ENDPOINTS(workspaceId).STUDENT.RESERVE_SLOT}/subjects`);
};
